<div class="circle" style=" z-index: 1;" *ngIf="spinner" >
    <div class="spinner"></div>
    <div class="inner-circle"></div>
</div>
<div class="block" [id]="idName" style="width: 100%; height: 100%;" ></div>